import paginationComponent from './pagination.component';

const paginationModule = angular.module('app.common.pagination', [])
	.component('pagination', paginationComponent)
	.name;

export default paginationModule;
